import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  allUsageReports: [],
  customerUsageReports: [],
  globalUsageTotals: [],
  customerUsageTotals: [],
  globalMonthlyBillingReport: [],
  exportCSVUsageReport: [],
  customerMonthlyBillingReport: [],
  customerClusterUsageReport: [],
  error: null,
};

const mbUsageSlice = createSlice({
  name: 'mbUsage',
  initialState,
  reducers: {
    setReducerError: (state, action) => {
      state.error = action.payload;
    },
    setAllUsageReports: (state, action) => {
      state.allUsageReports = action.payload;
      state.error = null;
    },
    setCustomerUsageReports: (state, action) => {
      state.customerUsageReports = action.payload;
      state.error = null;
    },
    setGlobalUsageTotals: (state, action) => {
      state.globalUsageTotals = action.payload;
      state.error = null;
    },
    setCustomerUsageTotals: (state, action) => {
      state.customerUsageTotals = action.payload;
      state.error = null;
    },
    setGlobalClusterUsageReport: (state, action) => {
      state.globalMonthlyBillingReport = action.payload;
      state.error = null;
    },
    setCustomerMonthlyBillingReport: (state, action) => {
      state.customerMonthlyBillingReport = action.payload;
      state.error = null;
    },
    setGlobalMonthlyBillingReport: (state, action) => {
      state.globalMonthlyBillingReport = action.payload; // state review
      state.error = null;
    },
    setCustomerClusterUsageReport: (state, action) => {
      state.customerClusterUsageReport = action.payload;
      state.error = null;
    },
    setExportCSVUsageReport: (state, action) => {
      state.exportCSVUsageReport = action.payload;
      state.error = null;
    },
    setResetMbUsage: () => {
      return initialState;
    },
  },
});

// Export actions and reducer
export const {
  setReducerError,
  setAllUsageReports,
  setCustomerUsageReports,
  setGlobalUsageTotals,
  setCustomerUsageTotals,
  setGlobalClusterUsageReport,
  setCustomerMonthlyBillingReport,
  setGlobalMonthlyBillingReport,
  setCustomerClusterUsageReport,
  setExportCSVUsageReport,
  setResetMbUsage,
} = mbUsageSlice.actions;

export default mbUsageSlice.reducer;
